import { useEffect } from "react";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import { TrustMarquee, Services, About } from "@/components/site/Story";
import Portfolio from "@/components/site/Portfolio";
import { Process, Zone } from "@/components/site/Sections2";
import { FinalCta, Contact, Footer, FloatingActions, CookieBanner } from "@/components/site/Contact";
import { BUSINESS } from "@/data";

export default function Landing() {
  useEffect(() => {
    document.title = "Officine Galloni · Fabbro a Montespertoli (FI) · Pronto intervento 24/7";

    const setMeta = (name, content) => {
      let m = document.querySelector(`meta[name="${name}"]`);
      if (!m) { m = document.createElement("meta"); m.setAttribute("name", name); document.head.appendChild(m); }
      m.setAttribute("content", content);
    };
    setMeta("description", "Officine Galloni, fabbri-serramentisti a Montespertoli (FI) dal 1979. Porte blindate, serrature, cancelli, ferro battuto su misura, restauro e pronto intervento 24/7. Preventivo chiaro.");

    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Locksmith",
      name: BUSINESS.name,
      image: "https://images.pexels.com/photos/177872/pexels-photo-177872.jpeg",
      telephone: BUSINESS.phone,
      email: BUSINESS.email,
      priceRange: "€€",
      address: { "@type": "PostalAddress", streetAddress: "Via Montelupo 21", addressLocality: "Montespertoli", addressRegion: "FI", postalCode: "50025", addressCountry: "IT" },
      openingHours: "Mo-Sa 08:00-19:00",
      areaServed: "Firenze",
      aggregateRating: { "@type": "AggregateRating", ratingValue: "4.7", reviewCount: "200" },
    });
    document.head.appendChild(ld);
    return () => { document.head.removeChild(ld); };
  }, []);

  return (
    <main className="relative bg-[#141414]">
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#1c1c1c", border: "1px solid rgba(200,155,74,0.3)", color: "#F5F1EA" } }} />
      <Header />
      <Hero />
      <TrustMarquee />
      <Services />
      <About />
      <Portfolio />
      <Process />
      <Zone />
      <FinalCta />
      <Contact />
      <Footer />
      <FloatingActions />
      <CookieBanner />
    </main>
  );
}
